import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import ViolationCompare from "./Charts/ViolationCompare";
import PPEChart from "./Charts/PPEChart";
import ViolationTrend from "./Charts/ViolationTrend";
import DateRangeFilter from "./common/DateRangeFilter";
import ViolationModal from "./Modals/ViolationModal";
import AreaWise from "./Charts/AreaWise";
import apiClient from "../apiClient/apiClient";
import {
  AREA_VIOLATION,
  FETCH_AI_MODEL,
  VIOLATION_GRAPH_URL,
  VIOLATION_RECENT_IMAGE_URL,
  VIOLATION_STATS_URL,
  VIOLATION_TREND_URL,
} from "../apiClient/apiEndpoints";
import { getNameInitials } from "../utils/common";
import { useSelector } from "react-redux";

const MainDashboard = () => {
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.user);
  const configData = useSelector((state) => state.config);
  const [photosModal, setPhotosModal] = useState(false);
  const [dates, setDates] = useState({ start: null, end: null });
  const [recentViolationImages, setRecentViolationImages] = useState([]);
  const [violationGraphStats, setViolationGraphStats] = useState();
  const [areaViolation, setAreaViolation] = useState([]);
  const [violationTrends, setViolationTrends] = useState([]);
  const [stats, setStats] = useState({});
  const [modelsList, setModelsList] = useState(0);
  const API_URL = configData?.config?.API_URL;

  const fetchViolationStats = async () => {
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${VIOLATION_STATS_URL}`, { params });
    setStats(res);
  };

  const fetchViolationGraphStats = async () => {
    setLoading(true);
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${VIOLATION_GRAPH_URL}`, { params });
    setViolationGraphStats(res);
    setLoading(false);
  };

  const fetchRecentViolationImages = async () => {
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${VIOLATION_RECENT_IMAGE_URL}`, { params });
    setRecentViolationImages(res);
  };

  const fetchViolationTrends = async () => {
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${VIOLATION_TREND_URL}`, { params });
    setViolationTrends(res);
  };

  const fetchViolationPerArea = async () => {
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${AREA_VIOLATION}`, { params });
    setAreaViolation(res);
  };

  const fetchModelList = async () => {
    const res = await apiClient.get(`${API_URL}${FETCH_AI_MODEL}`);
    setModelsList(res?.length ?? 0);
  };

  useEffect(() => {
    fetchRecentViolationImages();
    fetchViolationGraphStats();
    fetchViolationStats();
    fetchViolationTrends();
    fetchViolationPerArea();
  }, [dates?.start, dates?.end]);

  useEffect(() => {
    fetchModelList();
  }, []);

  return (
    <>
      <div className="container-fluid admindashboard p-4 pt-2 bg-grey-main">
        <div className="row align-items-center mt-0 mb-1">
          <div className="col-lg-6"></div>
          <div className="col-lg-6 d-flex align-items-center justify-content-end gap-4">
            <DateRangeFilter dates={dates} setDates={setDates} />
          </div>
        </div>

        <div className="datacardesign py-2">
          <div className="userdash">
            <div className="row w-100 h-100 justify-content-between">
              <div className="col-lg-8 d-flex align-items-center ">
                <div className="card cardesign welcomecard">
                  <div className="card-block d-flex align-items-center">
                    {loading ? (
                      <Skeleton width="70px" height="70px" circle baseColor="#ebebeb" highlightColor="#ffffff" />
                    ) : (
                      <>
                        <div className="profile-img">
                          {userData?.user?.group?.avatar ? (
                            <img src={userData.user.group.avatar} alt="" referrerPolicy="no-referrer" />
                          ) : (
                            <div className="initials-placeholder">{getNameInitials(userData?.user?.group?.name)}</div>
                          )}
                        </div>
                      </>
                    )}
                    <div className="welcomediv ps-3">
                      <h6 className="m-0 p-0">
                        {loading ? (
                          <Skeleton width="15rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                        ) : (
                          <>{userData?.user?.group?.name}</>
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="dashstatdata">
                  <div className="welcometext">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Areas </>} </p>
                    <h4>{loading ? <Skeleton width="5vw" /> : <> {areaViolation.length} </>} </h4>
                  </div>
                  <div className="welcometext">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Models </>} </p>
                    <h4>{loading ? <Skeleton width="5vw" /> : <> {modelsList} </>}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-9 pe-2">
            <div className="cardbox overflow-hidden custom-chart mt-2">
              <h5 className="mb-0">
                {loading ? (
                  <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                ) : (
                  "Violation Trend"
                )}
              </h5>
              <ViolationTrend loading={loading} isLoading={true} data={violationTrends} />
            </div>
          </div>

          <div className="col-lg-3 ps-2">
            <div className="cardbox overflow-hidden custom-chart mt-2">
              <h5 className="mb-0">
                {loading ? (
                  <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                ) : (
                  "People Detected"
                )}
              </h5>
              <ViolationCompare violationCount={stats?.violation} nonViolationCount={stats?.nonViolation} />
            </div>
          </div>
        </div>
      
         
            <div className="row">
              <div className="col-lg-6 pe-2">
                <div className="cardbox overflow-hidden custom-chart mt-3 image-slider">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="mb-0">
                      {loading ? (
                        <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                      ) : (
                        "Violation Incidents"
                      )}
                    </h5>
                  </div>
                  <PPEChart statsData={violationGraphStats} />
                </div>
              </div>
              <div className="col-lg-6 ps-2">
                <div className="cardbox overflow-hidden custom-chart mt-3">
                  <h5 className="mb-0">
                    {loading ? (
                      <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                    ) : (
                      "Area Wise Violation"
                    )}
                  </h5>
                  <AreaWise data={areaViolation} />
                </div>
              </div>
            </div>
      </div>

      <ViolationModal
        images={recentViolationImages}
        photosModal={photosModal}
        setPhotosModal={setPhotosModal}
        loading={loading}
      />
    </>
  );
};

export default MainDashboard;
